import React from "react";
import PropTypes from "prop-types";
import { STATUS_PENDING } from "common/constants/Constants";
import styles from "./styles.module.scss";

const AccountStatus = ({ status, bloombergSiteUrl }) => {
    return status === STATUS_PENDING
        ? <PendingAccountStatus bloombergSiteUrl={ bloombergSiteUrl } />
        : <StandardAccountStatus status={ status } />;
};

const PendingAccountStatus = ({ bloombergSiteUrl }) => {
    return (
        <div className={ styles.accountStatus }>
            <span className={ styles.label }>Status: </span>
            <span className={ styles.text }>Your subscription order is being processed.</span>
            <span className={ styles.reminderText }>
                You can continue accessing content on <a className={ styles.link } href={ bloombergSiteUrl }>Bloomberg.com</a>.
            </span>
        </div>
    );
};

const StandardAccountStatus = ({ status }) => {
    return (
        <div className={ styles.accountStatus }>
            <span className={ styles.label }>Status: </span>
            <span className={ styles.text }>{ status }</span>
        </div>
    );
};

AccountStatus.propTypes = {
    status: PropTypes.string.isRequired,
    bloombergSiteUrl: PropTypes.string.isRequired
};

PendingAccountStatus.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired
};

StandardAccountStatus.propTypes = {
    status: PropTypes.string.isRequired
};

export default AccountStatus;
